export default function(props, propName, componentName) {
  componentName = componentName || 'ANONYMOUS'

  if (props[propName]) {
    return new Error(
      `Passed prop "${propName}" with value "${props[propName]}" to ${componentName}. This prop will be overridden.`
    )
  }

  return null
}



// WEBPACK FOOTER //
// ../src/propValidators/overridden.js